import { useEffect } from 'react';
import api from '../api';

export function useHeartbeat() {
  useEffect(() => {
    const ping = () => {
      const token = localStorage.getItem('access_token');
      api.post('/heartbeat', null, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }).catch(() => {});
    };

    ping();
    const id = setInterval(ping, 30_000);
    return () => clearInterval(id);
  }, []);
}
